<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="640px" v-if="!isDomainFromBrazil">
      <v-card class="rounded-lg">
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="pl-3 mt-2">
            <span class="redirectTitle"
              >{{
                $t('message.pages.signup.redirectModal.titleWhenBrazil')
              }}
              🌍</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              <span class="textCta">{{
                $t(
                  'message.pages.signup.redirectModal.youAreAccessingFromGlobal'
                )
              }}</span>
            </v-row>
            <v-row no-gutters>
              <span class="textSub my-2">{{
                $t('message.pages.signup.redirectModal.priceBrazil')
              }}</span>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-8 pb-6 mt-4">
          <v-spacer></v-spacer>
          <base-btn
            type="tertiary"
            class="mr-2 px-10 rounded-lg elevation-0"
            @click="handleClose()"
          >
            {{ $t('message.pages.signup.redirectModal.cancel') }}
          </base-btn>
          <base-btn
            class="px-4 rounded-lg elevation-0"
            type="primary"
            @click="redirectPage(false)"
          >
            {{ $t('message.pages.signup.redirectModal.actionBrazil') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="open" width="640px" v-else>
      <v-card class="rounded-lg">
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="pl-3 mt-2">
            <span class="skipTitle"
              >{{ $t('message.pages.signup.redirectModal.titleWhenGlobal') }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              <span class="textCta">{{
                $t(
                  'message.pages.signup.redirectModal.youAreAccessingFromBrazil'
                )
              }}</span>
            </v-row>
            <v-row no-gutters>
              <span class="textSub my-2">{{
                $t('message.pages.signup.redirectModal.priceGlobal')
              }}</span>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-8 pb-6 mt-4">
          <v-spacer></v-spacer>
          <base-btn
            type="tertiary"
            class="mr-2 px-10 rounded-lg elevation-0"
            @click="handleClose()"
          >
            {{ $t('message.pages.signup.redirectModal.cancel') }}
          </base-btn>
          <base-btn
            class="px-4 rounded-lg elevation-0"
            type="primary"
            @click="redirectPage(true)"
          >
            {{ $t('message.pages.signup.redirectModal.actionGlobal') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'RedirectUrlSignup',
  components: {},
  data: () => ({
    open: null,
    isDomainFromBrasil: false,
  }),
  mounted() {
    this.$root.$on('redirectUrlSignup', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('redirectUrlSignup')
  },
  computed: {
    isDomainFromBrazil() {
      return location.host.match(/.com$/) ? false : true
    },
  },
  methods: {
    redirectPage(brazil = false) {
      window.location.href = `https://dashboard.pandavideo.com${
        brazil ? '.br' : ''
      }/#${this.$route.fullPath}`
      this.handleClose()
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
    },
  },
}
</script>

<style scoped lang="scss">
.redirectTitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 21.6px;
}
.textCta {
  font-weight: 400;
  font-size: 16px;
  line-height: 21.6px;
  color: $neutral-30-base-light;
}
.textSub {
  font-weight: 400;
  font-size: 16px;
  line-height: 24.6px;
  color: $neutral-40-light-light;
}
.bg-dark {
  .textCta {
    font-weight: 400;
    color: $neutral-30-base-dark;
  }
  .textSub {
    font-weight: 400;
    color: $neutral-40-light-dark;
  }
}
</style>
